export type Tier = 'High' | 'Medium' | 'Low' | 'Not established';

interface Placed { confidence: Tier; placement: 'matched' | 'seed' | 'drawn' }

/**
 * The confidence to state for the pin that is saved. A pin the user placed is theirs. Otherwise, once an outline matched
 * to the map is in use the pin is that outline's centre, so the outline's tier describes it: that tier already weighs the
 * location clue it was searched around, and a clue that is exact for the plan's map sheet (printed coordinates) says
 * little about where on that sheet the site is. An outline merely centred on the clue does not move the pin, so the
 * clue's own tier stands.
 */
export function effectiveLocationConfidence(args: { userEdited: boolean; locate: Tier; boundary: Placed | null }): Tier {
  if (args.userEdited) return 'High';
  if (args.boundary && args.boundary.placement === 'matched') return args.boundary.confidence;
  return args.locate;
}
